import webpartRegister from "./WebpartRegistration";
import UserInfoWebpart from "./HK/UserInfo/UserInfoWebpart.vue";
import BannerWebpart from "./KyoboBook/Banner/BannerWebpart.vue";
import SingleBannerWebpart from "./HK/Banner/SingleBannerWebpart.vue";

/**
 * NewStone
*/
import BoardArticleWebpart from "./NewStone/Board/BoardArticleWebpart.vue";
import BoardNoticeWebpart from "./NewStone/Board/BoardNoticeWebpart.vue";
import MyPeople from "./NewStone/MyPeples/MyPeoplesWebpart.vue";
import MyRecentFiles from "./NewStone/RecentFiles/RecentFilesWebpart.vue";
import MyTeams from "./NewStone/MyTeams/MyTeamsWebpart.vue";

/**
 * KyoboBook
*/
import ShortcutWebpart from "./KyoboBook/Shortcut/ShortcutWebpart.vue"
import ExternalShortcutWebpart from "./KyoboBook/Shortcut/ExternalShortcutWebpart.vue";
import MailListWebpart from "./KyoboBook/Mail/MailListWebpart.vue";
import RandomImageWebpart from "./KyoboBook/Today/RandomImageWebpart.vue";
import DataBannerWebpart from "./KyoboBook/Today/DataBannerWebpart.vue";
import CalendarWebpart from "./KyoboBook/Calendar/CalendarWebpart.vue";

// webpartRegister.register("user-info-webpart", UserInfoWebpart, "profile", "개인프로필 표시 웹파트", "사용자정보");
// webpartRegister.register("workflow-webpart", WorkflowWebpart, "workflow", "전자결재목록 표시 웹파트", "전자결재");
// webpartRegister.register("singlebanner-webpart", SingleBannerWebpart, "singlebanner", "단일 배너 웹파트", "단일배너");

/**
 * NewStone
*/
webpartRegister.register("noticeboard-webpart", BoardNoticeWebpart, "board", "공지사항목록 표시 웹파트", "공지사항");
webpartRegister.register("articleboard-webpart", BoardArticleWebpart, "board", "게시글목록 표시 웹파트", "게시판");
webpartRegister.register("my-people", MyPeople, "mypeople", "관련 인물 리스트", "관련 인물");
webpartRegister.register("my-recent-files", MyRecentFiles, "myRecentFiles", "나의 최근 파일", "나의 최근 파일");
// webpartRegister.register("my-teams", MyTeams, "myteams", "나의 팀즈", "나의 팀즈");

/**
 * KyoboBook
 * component name에 접두어 'kbb-' 추가
*/
webpartRegister.register("kbb-banner-webpart", BannerWebpart, "banner", "배너 표시 웹파트", "배너");
webpartRegister.register("kbb-shortcut-webpart", ShortcutWebpart, "shortcut", "바로가기 웹파트", "바로가기");
webpartRegister.register("kbb-external-shortcut-webpart", ExternalShortcutWebpart, "external-shortcut", "외부 바로가기 웹파트", "외부 바로가기");
webpartRegister.register("kbb-maillist-webpart", MailListWebpart, "mail", "메일 및 결재 리스트 웹파트", "메일 및 결재");
webpartRegister.register("kbb-random-image-webpart", RandomImageWebpart, "image", "이미지를 표시하는 웹파트", "이미지 배너");
webpartRegister.register("kbb-data-banner-webpart", DataBannerWebpart, "data", "데이터를 표시하는 웹파트", "데이터 배너");
webpartRegister.register("kbb-calendar-event", CalendarWebpart, "calendar", "달력,일정 표시 웹파트", "일정");
